import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
// let base64 = require('js-base64').Base64
export const adminModule = {
    ///获取菜单
    async getRoleMenuList() {

        return await httpRequest(baseUrl.basic + 'rolemenulist', 'get', null, null);
    },
    // 获取登录信息
    async getLoginAdminInfo(admin_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(admin_id) + 'FSG~AGD32Cf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'newadmininfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&admin_id=' + admin_id, 'get', null, null);
    },
    // 获取登录用户信息
    async newadminlogininfo(header) {
        return httpRequest(baseUrl.basic + 'newadminlogininfo', 'get', null, header);
        // const adminToken = store.getters.adminID
        // return await httpRequest(baseUrl.basic + 'newadminlogininfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&admin_id=' + admin_id, 'get', null, null);
    },
    // 修改密码
    async editLoginAdminPwd(password, repeatPassword) {
        const adminToken = store.getters.adminID
        var paras = {
            login_pwd: password,
            repeat_login_pwd: repeatPassword,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'dsds~Afs2Cf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'editadminloginpwd', 'post', qs.stringify(paras), null)
    },
    // 获取管理员列表信息
    async getAdminList(page, page_size, key_words, is_use, filter_region_id, admin_unit_name) {
        const adminToken = store.getters.adminID
        var paras = {
            key_words: key_words,
            is_use: is_use,
            page: page,
            page_size: page_size,
            filter_region_id: filter_region_id,
            admin_unit_name: admin_unit_name,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '32DAS~FDSACf', rsaBasicModuleConfig.clientPrivateKey),
        }
        console.log(adminToken)
        return await httpRequest(baseUrl.basic + 'newadminlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&key_words=' + key_words + '&is_use=' + is_use + '&page=' + page + '&page_size=' + page_size + '&filter_region_id=' + filter_region_id + '&admin_unit_name=' + admin_unit_name, 'get', null, null);

    },
    // 添加管理员
    async addAdmin(login_name, region_level, region_id, role_id, admin_unit_name) {
        const adminToken = store.getters.adminID
        var paras = {
            login_name: login_name,
            region_level: region_level,
            region_id: region_id,
            role_id: role_id,
            admin_unit_name: admin_unit_name,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(region_level) + String(region_id) + String(role_id) + 'dsD43#AdwCf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'newadminadd', 'put', qs.stringify(paras), null)
    },

    // 编辑管理员时获取信息
    async getAdminInfo(admin_id) {

        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(admin_id) + 'FSG~AGD32Cf', rsaBasicModuleConfig.clientPrivateKey),
        }
        console.log(adminToken)
        return await httpRequest(baseUrl.basic + 'newadmininfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&admin_id=' + admin_id, 'get', null, null);

    },
    // 编辑管理员
    async editAdmin(admin_id, adminName, admin_mobile_tel, admin_idcard_number, region_level, region_id, role_id, admin_unit_name) {
        const adminToken = store.getters.adminID
        var paras = {
            admin_id: admin_id,
            admin_name: adminName,
            admin_mobile_tel: admin_mobile_tel,
            admin_idcard_number: admin_idcard_number,
            region_level: region_level,
            region_id: region_id,
            role_id: role_id,
            admin_unit_name: admin_unit_name,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(admin_id) + String(region_level) + String(region_id) + String(role_id) + 'dsDdwCf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'newadminedit', 'post', qs.stringify(paras), null)
    },
    //注销/启用管理员
    async editadminusestatus(admin_id) {

        const adminToken = store.getters.adminID
        var paras = {
            admin_id: admin_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(admin_id) + 'FA3~ACd54f', rsaBasicModuleConfig.clientPrivateKey),
        }
        console.log(adminToken)
        return await httpRequest(baseUrl.basic + 'editadminusestatus', 'post', qs.stringify(paras), null);

    },
    //初始化密码
    async initadminpwd(admin_id) {

        const adminToken = store.getters.adminID
        var paras = {
            admin_id: admin_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(admin_id) + 'sfmkf', rsaBasicModuleConfig.clientPrivateKey),
        }
        console.log(adminToken)
        return await httpRequest(baseUrl.basic + 'initadminpwd', 'post', qs.stringify(paras), null);

    },
    //完善信息
    async complateadmininfo(admin_name, admin_mobile_tel, admin_idcard_number, login_pwd, repeat_login_pwd) {
        const adminToken = store.getters.adminID
        var paras = {
            admin_name: admin_name,
            admin_mobile_tel: admin_mobile_tel,
            admin_idcard_number: admin_idcard_number,
            login_pwd: login_pwd,
            repeat_login_pwd: repeat_login_pwd,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'dskflkf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'complateadmininfo', 'post', qs.stringify(paras), null)
    },
    // 修改管理员密码
    async editAdminPwd(adminID, adminLoginPwd, repeatLoginPwd) {
        const adminToken = store.getters.adminID
        var paras = {
            admin_id: adminID,
            admin_login_pwd: adminLoginPwd,
            repeat_login_pwd: repeatLoginPwd,
            add_sign: rsa.signString(adminToken + '~A' + adminLoginPwd + '%%', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'admineditpwd', 'post', qs.stringify(paras), null)
    },
    // 删除管理员信息
    async deleteAdmin(adminID) {
        const adminToken = store.getters.adminID
        var paras = {
            a_id: adminID,
            admin_sign: rsa.signString(adminToken + '~*' + adminID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'deladmin', 'post', qs.stringify(paras), null)
    },
    // 撤销实名认证
    async revokeadminauth(adminID) {
        const adminToken = store.getters.adminID
        var paras = {
            admin_id: adminID,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + adminID + 'sfmkf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'revokeadminauth', 'post', qs.stringify(paras), null)
    },
    //获取当前政策的年份
    async biztimesetgetyear() {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'sasjkfjd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'v2/biztimesetgetyear?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },

}
export const roleModule = {
    // 获取角色
    async getRoleList(keywords) {
        if (keywords && keywords.length > 0) {
            return await httpRequest(baseUrl.basic + 'rolelist?key=' + keywords, 'get', null, null)
        }
        return await httpRequest(baseUrl.basic + 'rolelist', 'get', null, null)
    },
    async addRole(roleName) {
        var paras = {
            role_name: roleName
        }
        return await httpRequest(baseUrl.basic + 'addrole', 'put', qs.stringify(paras), null)
    },
    async editRole(roleID, roleName) {
        var paras = {
            role_id: roleID,
            role_name: roleName,
        }
        return await httpRequest(baseUrl.basic + 'editrole', 'post', qs.stringify(paras), null)
    },
    async deleteRole(roleID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            role_sign: rsa.signString(adminToken + '~' + roleID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'delrole', 'post', qs.stringify(paras), null)
    },
    async getRolePermissionList(roleID) {
        return await httpRequest(baseUrl.basic + 'rolepermission?role_id=' + roleID, 'get', null, null)
    },
    async roleAddPermission(roleID, authID, menuID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_id: authID,
            menu_id: menuID,
            p_sign: rsa.signString(adminToken + '~' + roleID + '|' + menuID + '%' + authID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'addpermission', 'put', qs.stringify(paras), null)
    },
    async roleDeletePermission(roleID, authID, menuID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_id: authID,
            menu_id: menuID,
            p_sign: rsa.signString(adminToken + '~' + roleID + '|' + menuID + '%' + authID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'deletepermission', 'post', qs.stringify(paras), null)
    },
    async roleAddSubMenuPermission(roleID, authID, menuID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_id: authID,
            menu_id: menuID,
            p_sign: rsa.signString(adminToken + '~' + roleID + '|' + menuID + '%' + authID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'addsubmenupermission', 'put', qs.stringify(paras), null)
    },
    async roleDeleteSubMenuPermission(roleID, authID, menuID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_id: authID,
            menu_id: menuID,
            p_sign: rsa.signString(adminToken + '~' + roleID + '|' + menuID + '%' + authID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'deletesubmenupermission', 'post', qs.stringify(paras), null)
    },
    async roleAddMenuPermission(roleID, authID, menuID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_id: authID,
            menu_id: menuID,
            p_sign: rsa.signString(adminToken + '~' + roleID + '|' + menuID + '%' + authID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'addmenupermission', 'put', qs.stringify(paras), null)
    },
    async roleDeleteMenuPermission(roleID, authID, menuID) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_id: authID,
            menu_id: menuID,
            p_sign: rsa.signString(adminToken + '~' + roleID + '|' + menuID + '%' + authID, rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'deletemenupermission', 'post', qs.stringify(paras), null)
    }



}

export const secondRoleModule = {
    async getSuRoleMenuRolePermissionList(roleID) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + roleID + 'sd8jgHV%jd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'surolemenupermissionlist?role_id=' + roleID + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },

    async getRoleMenuListThree() {
        return await httpRequest(baseUrl.basic + 'rolemenulistthree', 'get', null, null);
    },

    async batchAddSuRolePermission(roleID, permissionIDs) {
        const adminToken = store.getters.adminID
        var paras = {
            role_id: roleID,
            permission_ids: permissionIDs,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + roleID + '~AFksd8vd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'batchaddsurolepermission', 'put', qs.stringify(paras), null)
    },




}